import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import './index.css';
import 'antd/dist/reset.css';

// Habilita o parsing de datas por mascara (ex: dayjs(valor, 'DD.MM.YYYY')).
// Sem este plugin o dayjs ignora a mascara e cai no parser nativo (formato
// americano), gerando datas trocadas ou "Invalid Date" para dia > 12.
dayjs.extend(customParseFormat)

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
